/**
 * Compatibility shim for `@remix-validated-form/with-zod`. The original wrapped
 * a zod schema into a remix-validated-form Validator with a `.validate()` used
 * by server actions. In the SPA we only need the schema, which our
 * `ValidatedForm` shim feeds to `zodResolver`.
 *
 * Aliased to `@remix-validated-form/with-zod` (see vite.config.ts + tsconfig).
 */
import type { ZodTypeAny } from 'zod';
import type { Validator } from '@/forms/remixValidatedForm';

export function withZod<T extends ZodTypeAny>(schema: T): Validator<T> {
    return { schema };
}
